import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEarLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 25,
	viewBox: "0 0 18 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18 25C9.75823 18.2905 8.99377 10.3041 15.1694 0C7.37812 4.58187 -2.32816 13.0068 0.502472 25H18Z",
		fill: "#CCCACA"
	})
});
export default SvgEarLeft;
